import React, { useState } from "react";
import "./TooltipPopover.css";

const TooltipPopover = ({
  type = "tooltip", // 'tooltip' or 'popover'
  title = "Title",
  description = "Description",
  position = "top", // 'top', 'bottom', 'left', 'right'
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    if (type === "tooltip") setIsVisible(true);
  };

  const handleMouseLeave = () => {
    if (type === "tooltip") setIsVisible(false);
  };

  const handleClick = () => {
    if (type === "popover") setIsVisible((prev) => !prev);
  };

  return (
    <div
      className="tooltip-popover-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {children}
      <div
        className={`popup-box ${type} ${position} ${
          isVisible ? "visible" : ""
        }`}
      >
        <div className="popup-content">
          <h4 className="popup-title">{title}</h4>
          <p className="popup-description mt-3">{description}</p>
          <button className="btn btn-primary mt-3">Top</button>
        </div>
      </div>
    </div>
  );
};

export default TooltipPopover;
